/* eslint-disable no-restricted-globals */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles, IconButton, Menu, MenuItem } from '@material-ui/core'
import { MoreVert, Delete } from '@material-ui/icons'
import classNames from 'classnames'
import { deleteEntity, update, list, create } from 'actions/data'
import NumberFormat from 'react-number-format'
import language from 'utils/vast-languagepack'
import ReactSelect from 'components/theme/Select'
import styles from './styles'
import CanadianAreaCodes from './CanadianAreaCodes'
import US from 'utils/flags/US.png'
import CA from 'utils/flags/CA.png'
import { createSelector } from 'reselect'
import { toggleDialog } from 'actions/view'
import { DATA_API_URL } from 'utils/AllURLs'
import { v4 as uuidv4 } from 'uuid'

const customStyles = {
  control: provided => ({
    ...provided,
    borderRadius: '28px',
    padding: 0,
  }),
  menu: provided => ({
    ...provided,
    zIndex: 2,
    minWidth: 250,
  }),
}

// Create a memoized selector for the relationship
// const getPhoneToUseCaseMap = createSelector(
//   [
//     state => Object.values(state.data.a2p10dlc?.[0] || {})?.phones || {},
//     state => Object.values(state.data.a2p10dlc?.[0] || {})?.messagingServices || {},
//     state => Object.values(state.data.a2p10dlc?.[0] || {})?.campaigns || {},
//   ],
//   (phones, messagingServices, campaigns) => {
//     // Build an efficient lookup map once
//     const lookupMap = {}

//     // This calculation happens only when the data changes
//     Object.entries(phones).forEach(([phoneSid, phone]) => {
//       if (!phone.serviceSid) return

//       const campaign = Object.entries(campaigns).find(([_, c]) =>
//         c.messagingServiceSid === phone.serviceSid
//       )

//       if (campaign) {
//         lookupMap[phoneSid] = campaign[0] // useCase
//       }
//     })

//     return lookupMap
//   }
// )

// Add this selector outside the component
const getPhoneUseCase = createSelector(
  [
    state => Object.values(state.data.a2p10dlc || {})?.[0]?.phones || {},
    (_, phoneNumber) => phoneNumber,
  ],
  (phones, phoneNumber) => {
    const phone = phones[phoneNumber.phone_number_sid]
    return phone?.serviceSid || null // Simply return the serviceSid
  },
)

// Add a selector for available use cases
const getAvailableUseCases = createSelector(
  [
    state =>
      Object.values(state.data.a2p10dlc || {})?.[0]?.messagingServices || {},
  ],
  messagingServices => {
    return Object.entries(messagingServices)
      .map(([useCase, service]) => ({
        value: service.sid,
        label: useCase.replace(/_/g, ' '),
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  },
)

const ListItem = connect(
  (state, { number }) => ({
    users: state.data.user,
    useCase: number.useCase || getPhoneUseCase(state, number),
    availableUseCases: getAvailableUseCases(state),
    username: state.auth.session?.idToken?.payload['custom:username'],
    a2p10dlcID: Object.values(state.data.a2p10dlc || {})?.[0]?.id,
  }),
  dispatch =>
    bindActionCreators(
      { update, deleteEntity, toggleDialog, list, create },
      dispatch,
    ),
)(
  withStyles(styles)(
    class ListItemComponent extends Component {
      state = {
        menuOpen: false,
        forwardingNumber: this.props.number.callforwarding_number.slice(2),
        anchorEl: null,
        country: 'US',
        useCaseLoading: false,
      }

      handleClick = event => {
        this.setState({ anchorEl: event.currentTarget })
      }

      handleClose = () => {
        this.setState({ anchorEl: null })
      }

      handleValueChange = valuesObj => {
        const { number, update } = this.props

        this.setState({ forwardingNumber: valuesObj.value })

        const obj = {
          id: number.id,
          phone_number: number.phone_number,
        }

        if (valuesObj.value.length > 9) {
          obj.callforwarding_number = `+1${valuesObj.value}`
        }

        if (number.vast_user_name) {
          obj.vast_user_name = number.vast_user_name
        }

        if (valuesObj.value.length > 9 || valuesObj.value.length === 0) {
          update(obj, 'phonenumbers', null, 'phonenumbers/id')
        }
      }

      handleUseCaseChange = async (newValue, oldValue) => {
        if (newValue.value === 'divider') return

        if (newValue.value === 'add_new') {
          this.props.toggleDialog({ open: true, dialog: 'AddUseCase' })
          return
        }

        this.setState({ useCaseLoading: true })

        try {
          const requestUUID = uuidv4()
          // Initial request remains the same
          await this.props.create({
            entityType: 'a2p10dlc',
            entity: {
              requests: {
                [requestUUID]: {
                  username: this.props.username,
                  requestUUID,
                  directive: 'changePhoneUseCase',
                  phone_number_sid: this.props.number?.phone_number_sid,
                  fromService: oldValue?.value,
                  toService: newValue?.value,
                  status: 'pending',
                  createdAt: new Date().toISOString(),
                  updatedAt: new Date().toISOString(),
                },
              },
              requestUUID,
              directive: 'changePhoneUseCase',
              id: this.props.a2p10dlcID,
            },
            noReturnValue: true,
            url: `${DATA_API_URL}/a2p10dlc`,
            hasSchema: false,
            snackbarMessage: 'none',
          })

          // Start polling
          const startTime = Date.now()
          const TIMEOUT = 60000 // 1 minute timeout
          const INTERVAL = 5000 // 5 seconds between polls

          const pollStatus = async () => {
            // console.log('Polling at:', new Date().toISOString())
            
            const response = await this.props.list(
              'a2p10dlc',
              null,
              `${DATA_API_URL}/a2p10dlc`,
            )
            // console.log('response: ', response)
            
            const data = response?.response?.[0] // Get first item from array
            // console.log('data: ', data)
            // console.log('requestUUID', requestUUID)
            const request = data?.requests?.[requestUUID]
            // console.log('request: ', request)
            // console.log('Current request status:', request?.status)

            // if (!request) {
            //   throw new Error('Request not found')
            // }

            if (
              request?.status === 'success' ||
              request?.status === 'failure'
            ) {
              return request.status // This return might be getting lost in the Promise chain
            }

            if (Date.now() - startTime > TIMEOUT) {
              throw new Error('timeout')
            }

            // Wait for next interval and continue polling
            return new Promise(resolve => {
              setTimeout(() => {
                resolve(pollStatus())
              }, INTERVAL)
            })
          }

          // Let's also add some debug logging to track the flow
          const finalStatus = await pollStatus()
          console.log('Polling completed with status:', finalStatus)
          if (finalStatus === 'failure') {
            throw new Error('Request failed')
          }
        } catch (error) {
          console.error('Use case change error:', error)
          // Handle different error cases
          const errorMessage =
            error.message === 'timeout'
              ? 'Request timed out'
              : 'Something went wrong while changing the use case'
          console.log(errorMessage)

          // You might want to show this error to the user via a snackbar or other UI element
          // this.props.toggleDialog({
          //   open: true,
          //   dialog: 'ErrorDialog',
          //   dialogProps: { message: errorMessage }
          // })
        } finally {
          this.setState({ useCaseLoading: false })
        }
      }

      render() {
        const {
          idx,
          classes,
          number,
          update,
          deleteEntity,
          users,
          listLength,
          useCase,
          availableUseCases,
        } = this.props

        const { forwardingNumber, anchorEl } = this.state

        const obj = number.callforwarding_number
          ? {
              id: number.id,
              phone_number: number.phone_number,
              callforwarding_number: number.callforwarding_number,
            }
          : {
              id: number.id,
              phone_number: number.phone_number,
            }

        const userArr = users ? Object.values(users) : []

        const userOptions = userArr.map(user => ({
          value: user.user_name,
          label:
            user.first_name || user.last_name
              ? `${user.first_name || ''} ${user.last_name || ''}`
              : user.user_name,
        }))

        const selectOptions = [{ value: null, label: 'None' }, ...userOptions]

        if (!users) return null

        // Create options with a divider and "Add new" option
        const USE_CASE_OPTIONS = [
          ...availableUseCases,
          {
            value: 'divider',
            label: '_____________________',
            isDisabled: true,
          },
          { value: 'add_new', label: '+ Add new use case' },
        ]

        const currentUseCaseValue = this.state.useCaseLoading
          ? { value: 'loading', label: 'Loading...' }
          : USE_CASE_OPTIONS.find(
              option =>
                option.value === useCase && // useCase is now the serviceSid
                option.value !== 'divider' &&
                option.value !== 'add_new',
            ) || null

        return (
          <div
            className={classNames(
              listLength <= 1 ? classes.singleListItem : classes.listItem,
              // idx % 2 === 0 ? classes.even : null,
              listLength > 1 && idx === 0 ? classes.first : null,
              listLength > 1 && idx === listLength - 1 ? classes.last : null,
            )}
            style={{ paddingRight: 50 }}
          >
            <span className={classes.item} style={{ position: 'relative' }}>
              <div className={classes.phoneNumberLabel}>Phone Number</div>
              <img
                src={
                  CanadianAreaCodes[number?.phone_number?.slice(2, 5)] ? CA : US
                }
                alt={
                  CanadianAreaCodes[number?.phone_number?.slice(2, 5)]
                    ? 'CA'
                    : 'US'
                }
                style={{
                  marginRight: 5,
                  width: 22,
                  marginLeft: 20,
                  verticalAlign: 'middle',
                }}
              />
              <NumberFormat
                format={`+1 (###) ###-####`}
                value={number?.phone_number?.slice(2)}
                displayType="text"
                className={classNames(
                  classes.phoneNumber /* , classes.firstItem */,
                )}
              />
            </span>
            <span
              className={classNames(
                classes.item,
                classes.forwardingNumberSection,
              )}
              style={{
                // marginRight: 20,
                // marginTop: 17,
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: -14,
                  left: 7,
                  fontSize: 11,
                  color: 'gray',
                }}
              >
                Call Forwarding Number
              </div>
              <NumberFormat
                onBlur={() => {
                  if (forwardingNumber && forwardingNumber.length < 9) {
                    this.setState({
                      forwardingNumber: number.callforwarding_number,
                    })
                  }
                }}
                onValueChange={this.handleValueChange}
                className={classNames(
                  classes.callForwardingNumber /* , classes.thirdItem */,
                )}
                value={forwardingNumber}
                placeholder="Enter forwarding number"
                format={`+1 (###) ###-####`}
                mask="_"
                removeFormatting={formattedValue => console.log(formattedValue)}
                onPaste={e => {
                  const pastedText = e.clipboardData.getData('Text')
                  e.preventDefault()
                  if (typeof pastedText === 'string') {
                    let modifiedText = pastedText.replace(/[^0-9]+/g, '').trim()
                    const difference = modifiedText.length - 10
                    if (difference > 0) {
                      modifiedText = modifiedText.slice(difference)
                    }

                    this.handleValueChange({ value: modifiedText })
                  }
                }}
                type="tel"
              />
            </span>
            <span className={classNames(classes.item, classes.select)}>
              <div
                style={{
                  position: 'absolute',
                  top: -14,
                  left: 5,
                  fontSize: 11,
                  color: 'gray',
                }}
              >
                Assign number to a team member
              </div>
              <ReactSelect
                styles={customStyles}
                value={
                  number.vast_user_name
                    ? {
                        value: number.vast_user_name,
                        label:
                          users[number.vast_user_name] &&
                          (users[number.vast_user_name].first_name ||
                            users[number.vast_user_name].last_name)
                            ? `${
                                users[number.vast_user_name].first_name || ''
                              } ${users[number.vast_user_name].last_name || ''}`
                            : number.vast_user_name,
                      }
                    : { value: null, label: 'None' }
                }
                onChange={newValue =>
                  update(
                    { ...obj, vast_user_name: newValue.value },
                    'phonenumbers',
                    null,
                    'phonenumbers/id',
                  )
                }
                closeMenuOnSelect
                options={selectOptions}
                placeholder="Select a user"
              />
            </span>
            <span className={classNames(classes.item, classes.select)}>
              <div
                style={{
                  position: 'absolute',
                  top: -14,
                  left: 5,
                  fontSize: 11,
                  color: 'gray',
                }}
              >
                Use case
              </div>
              <ReactSelect
                styles={customStyles}
                value={currentUseCaseValue}
                onChange={newValue =>
                  this.handleUseCaseChange(newValue, currentUseCaseValue)
                }
                isDisabled={this.state.useCaseLoading}
                closeMenuOnSelect
                options={USE_CASE_OPTIONS}
                placeholder="Select a use case"
              />
            </span>
            <div className={classes.moreIcon}>
              <IconButton
                aria-owns={anchorEl ? 'phone-menu' : undefined}
                aria-haspopup="true"
                onClick={this.handleClick}
                classes={{ root: classes.moreIconRoot }}
              >
                <MoreVert />
              </IconButton>
            </div>
            <Menu
              id="phone-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem
                onClick={() => {
                  this.setState({ anchorEl: null })
                  deleteEntity(number.id, 'phonenumbers')
                }}
              >
                <Delete className={classes.leftIcon} />
                {language.managePhone.delete}
              </MenuItem>
            </Menu>
          </div>
        )
      }
    },
  ),
)

export default ListItem
